import { render, staticRenderFns } from "./biddingDetails.vue?vue&type=template&id=0d29fe91&scoped=true&"
import script from "./biddingDetails.vue?vue&type=script&lang=js&"
export * from "./biddingDetails.vue?vue&type=script&lang=js&"
import style0 from "./biddingDetails.vue?vue&type=style&index=0&id=0d29fe91&prod&scoped=true&lang=css&"
import style1 from "./biddingDetails.vue?vue&type=style&index=1&id=0d29fe91&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d29fe91",
  null
  
)

export default component.exports